import { render, staticRenderFns } from "./PaymentFormIcon.vue?vue&type=template&id=2d84e48c&functional=true&"
import script from "./PaymentFormIcon.vue?vue&type=script&lang=js&"
export * from "./PaymentFormIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports